import keyMirror from 'keymirror';

export const PREMIER = keyMirror({
  LIGHT: null,
  NO_OFFER: null,
  ONE_MIXED: null,
  ONE: null,
  PREMIER: null,
  PREMIER_MIXED: null,
  UPGRADE_VOUCHER: null,
});